module.exports = __webpack_public_path__ + "static/media/IMG_3495-min.ce1d88cd.JPG";